module.exports = __webpack_public_path__ + "static/img/5960_phase_function_Paper_PointsHejduk_Prediction.583a392.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5960_phase_function_Paper_PointsHejduk_Prediction.png
// module id = I6Ng
// module chunks = 0